// extracted by mini-css-extract-plugin
module.exports = {"questionWrapper":"FaqPart_questionWrapper__W3xaJ","answer":"FaqPart_answer__WuPIj"};
module.exports.__checksum = "fa3cc6d99787"
